import { FeatureContext, Features, featureOperations } from '@ardoq/features';

/**
 * Check if the current user can administer broadcasts, i.e. access the
 * Broadcasts module, the broadcasts collection and broadcast assets
 * (checks for role and feature).
 * @returns {boolean}
 */
const canAdminBroadcasts = (featureContext: FeatureContext): boolean =>
  featureOperations.hasFeature(featureContext, Features.BROADCASTS) &&
  featureContext.isOrgAdmin;

export const broadcastAccessControlInterface = {
  canAdminBroadcasts,
};
